/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Exceptions_ValueInputs */

const en_how_we_work_brief_exceptions_value = /** @type {(inputs: How_We_Work_Brief_Exceptions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing information goes to the account owner`)
};

const lv_how_we_work_brief_exceptions_value = /** @type {(inputs: How_We_Work_Brief_Exceptions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trūkstošā informācija nonāk pie atbildīgā darbinieka`)
};

/**
* | output |
* | --- |
* | "Missing information goes to the account owner" |
*
* @param {How_We_Work_Brief_Exceptions_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_exceptions_value = /** @type {((inputs?: How_We_Work_Brief_Exceptions_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Exceptions_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_exceptions_value(inputs)
	return en_how_we_work_brief_exceptions_value(inputs)
});